<template>
    <teleport to="body">
        <transition leave-active-class="duration-200">
            <div v-show="show" class="fixed inset-0 overflow-y-auto px-4 py-6 sm:px-0 z-50" scroll-region>
                <div v-show="show" class="fixed inset-0 transform transition-all" @click="close">
                    <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
                </div>
                <div v-show="show" class="flex items-center justify-center h-screen">
                    <div class="mb-6 bg-white rounded-3xl overflow-hidden shadow-xl transform transition-all w-[320px] p-5 text-center">
                        <span class="text-[30px] font-bold">What type of training do you want?</span>
                        <div class="mt-4">
                            <button @click="select('online')"
                                v-if="master.online_course_status"
                                class="custom-button w-full bg-yellow-400 text-lg shadow-md sm:mt-1 px-3 py-1 rounded-full text-white hover:shadow-xl transition duration-500 ease-in-out hover:bg-yellow-500 focus:ring focus:ring-yellow-500">
                                Online
                            </button>
                            <button @click="select('in_person')"
                                v-if="master.in_person_course_status"
                                class="custom-button w-full bg-yellow-400 text-lg shadow-md mt-2 px-3 py-1 rounded-full text-white hover:shadow-xl transition duration-500 ease-in-out hover:bg-yellow-500 focus:ring focus:ring-yellow-500">
                                In-person
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </teleport>
</template>

<script>
export default {
    emits: ['select', 'close'],
    props: {
        show: {
            default: false
        },
        master: {
            default: {},
            type: Object
        }
    },
    methods:{
        close(){
            this.$emit('close');
        },
        select(_type){
            this.$emit('select', _type);
        }
    }
}
</script>
